<template>
  <InformationIcon />

  <div class="as-d-flex as-flex-column as-box-match-info">
    <div
      v-for="(arg, key) in args"
      :key="key"
      class="as-item as-d-flex as-align-items-center"
    >
      <div class="as-icon">
        <img
          v-if="key === 'league'"
          :src="arg.icon"
          class="as-icon"
          width="37"
          height="37"
        />
        <svg
          v-else
          class="as-icon"
          width="37"
          height="37"
          viewBox="0 0 37 37"
          aria-hidden="true"
        >
          <use :xlink:href="'#' + arg.icon"></use>
        </svg>
      </div>
      <div class="as-info">
        <div class="as-name">{{ arg.name }}</div>
        <div class="as-nation">
          {{ arg.value }}
          <div v-if="key == 'referee' && arg.country_id">
            <img
              :src="getImgUrlBySport('country', arg.country_id)"
              :alt="arg.name"
            />
          </div>
        </div>
        <!-- <div
          v-if="
            key == 'referee' &&
            (arg.red_card_percent || arg.yellow_card_percent)
          "
          class="as-referee-description"
        >
          Thẻ trung bình:
          <svg
            class="as-icon"
            width="11"
            height="13"
            viewBox="0 0 11 13"
            aria-hidden="true"
          >
            <use xlink:href="#iconRedCard"></use>
          </svg>
          {{ arg.red_card_percent }}
          <svg
            class="as-icon"
            width="11"
            height="13"
            viewBox="0 0 11 13"
            aria-hidden="true"
          >
            <use xlink:href="#iconYellowCard"></use>
          </svg>
          {{ arg.yellow_card_percent }}
        </div> -->
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { defineProps, computed, getCurrentInstance } from "vue";
import type { IMatch } from "~src/interfaces";
import InformationIcon from "~src/components/matches/InformationIcon.vue";

interface IProps {
  match: IMatch;
}

const props = withDefaults(defineProps<IProps>(), {});

const args = computed(() => {
  const instance: any = getCurrentInstance();
  const data = {
    league: {
      icon:  instance.proxy?.getImgUrlBySport("competition", props.match.competition_id),
      name: "Giải đấu",
      value:
        props.match.competition?.name !== ""
          ? props.match.competition?.name
          : null,
    },
  } as { [key: string]: any };

  if (props.match.round?.round_num) {
    data.round = {
      icon: "iconround",
      name: "Vòng thi đấu",
      value:
        props.match.round?.round_num !== 0
          ? props.match.round?.round_num
          : null,
    };
  }
  if (props.match.venue?.name) {
    data.stadium = {
      icon: "iconstadium",
      name: "Sân vận động",
      value: props.match.venue?.name,
    };
  }
  if (props.match.environment?.temperature) {
    data.temperature = {
      icon: "icontemperature",
      name: "Nhiệt độ",
      value: props.match.environment?.temperature,
    };
  }
  if (props.match.referee?.name) {
    data.referee = {
      icon: "iconreferee",
      name: "Trọng tài",
      value: props.match.referee?.name,
      country_id: props.match.referee?.country_id,
      yellow_card_percent: props.match.referee?.yellow_card_percent,
      red_card_percent: props.match.referee?.red_card_percent,
    };
  }

  if (props.match.coach && props.match.coach.home) {
    data.coach_home = {
      icon: "iconOachHome",
      name: "HLV đội chủ",
      value: props.match.coach.home.name,
    };
  }

  if (props.match.coach && props.match.coach.away) {
    data.coach_away = {
      icon: "iconOachAway",
      name: "HLV đội khách",
      value: props.match.coach.away.name,
    };
  }

  return data;
});
</script>

<script lang="ts">
export default {};
</script>
